import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "./firebase"; // Adjust path as needed

const getFilteredDocuments = async (collectionName, field, operator, value) => {
  const q = query(
    collection(db, collectionName),
    where(field, operator, value)
  );
  const querySnapshot = await getDocs(q);
  const documents = [];
  querySnapshot.forEach((doc) => {
    documents.push({ id: doc.id, ...doc.data() });
  });
  return documents;
};
export { getFilteredDocuments };